/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessClinicalExceptionResponse } from '../models/SuccessClinicalExceptionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClinicalExceptionControllerService {

    /**
     * Returns the latest active clinical exception recorded for the authenticated user.
     * @returns SuccessClinicalExceptionResponse OK
     * @throws ApiError
     */
    public static getLatestActiveClinicalExceptionForCurrentUser(): CancelablePromise<SuccessClinicalExceptionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/partners/clinical-exceptions',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Derives and records a new clinical exception for the authenticated user from their already-saved questionnaire answers and profile data.
     * @returns string Clinical exception created successfully
     * @throws ApiError
     */
    public static storeClinicalExceptionForCurrentUser(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/partners/clinical-exceptions',
            responseHeader: 'X-NineamHealth-TraceId',
            errors: {
                400: `No clinical exception condition applies to the user's saved data`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
